document.documentElement.classList.remove('no-js');
/* nk — red de seguridad: si algo falla, la página nunca queda oculta (la fuente no usa .reveal) */
setTimeout(function(){document.documentElement.classList.add('trn-nk-ready');},2500);

/* nk — clases de página de la fuente (script20 + script25) */
(function(){var h=document.documentElement;h.classList.add('trn-nk-page','trn-nk-ready');var b=function(){document.body&&document.body.classList.add('trn-nk-page');};b();document.addEventListener('DOMContentLoaded',b,{once:true});})();

/* nk — Releasit: selectores de los dos DOM (antiguo y v458) */
var NK_RSI_BTN='._rsi-buy-now-button, #rsi_buy_now_button:not(.rsi_floating)';
var NK_RSI_MODAL='#_rsi-cod-form-modal._rsi-cod-form-modal-open, dialog#rsi_form_wrapper[open]';
var NK_RSI_OFFER='._rsi-quantity-offers-offer-container';
var NK_RSI_OFFER_FALLBACK='[class*="quantity-offer"]';
var NK_RSI_SEL='_rsi-quantity-offers-selected';
window.NK_SELECTED_IDX=1;

(function(){
  function offersIn(scope){
    var list=scope.querySelectorAll(NK_RSI_OFFER);
    if(list.length) return list;
    var c=scope.querySelectorAll(NK_RSI_OFFER_FALLBACK),groups=[],best=[];
    for(var i=0;i<c.length;i++){var p=c[i].parentNode,g=null;for(var j=0;j<groups.length;j++) if(groups[j].p===p){g=groups[j];break;}if(!g){g={p:p,items:[]};groups.push(g);}g.items.push(c[i]);}
    for(var m=0;m<groups.length;m++) if(groups[m].items.length>best.length) best=groups[m].items;
    return best.length>1?best:[];
  }
  function isSelected(el){
    if(el.classList.contains(NK_RSI_SEL)||el.querySelector('.'+NK_RSI_SEL)) return true;
    if(/(^|[\s_-])(selected|active|checked)([\s_-]|$)/i.test(el.className||'')) return true;
    var inp=el.querySelector('input[type="radio"]');
    return !!(inp&&inp.checked)||el.getAttribute('aria-checked')==='true';
  }
  var syncing=false;
  function syncReleasit(){
    if(syncing) return; syncing=true;
    var t0=Date.now(),done=false,mo=null,clicks=0,last=0;
    function finish(){done=true;syncing=false;if(mo){mo.disconnect();mo=null;}}
    function apply(){
      if(done) return true;
      var modal=document.querySelector(NK_RSI_MODAL); if(!modal) return false;
      var offers=offersIn(modal); if(!offers.length) offers=offersIn(document);
      if(!offers.length) return false;
      var el=offers[window.NK_SELECTED_IDX|0]; if(!el){finish();return true;}
      if(isSelected(el)){finish();return true;}
      var target=el.querySelector('._rsi-quantity-offers-offer')||el.querySelector('input[type="radio"]')||el;
      if(clicks<6&&Date.now()-last>250){clicks++;last=Date.now();try{target.click();}catch(e){}}
      return false;
    }
    if(apply()) return;
    if(window.MutationObserver){
      mo=new MutationObserver(function(){if(apply()) return;if(Date.now()-t0>6000) finish();});
      mo.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['class','open']});
    }
    (function poll(){if(done) return;if(apply()) return;if(Date.now()-t0>6000){finish();return;}setTimeout(poll,150);})();
  }
  document.addEventListener('click',function(e){
    var h=document.getElementById('nkReleasitHost'); if(!h||!e.target||!e.target.closest) return;
    var t=e.target.closest(NK_RSI_BTN); if(t&&h.contains(t)) syncReleasit();
  },true);
  window.nkOpenReleasit=function(){
    var h=document.getElementById('nkReleasitHost'),b=h&&h.querySelector(NK_RSI_BTN);
    if(!b) return false; b.click(); return true;
  };
  /* si la app no pinta su botón, se muestra el bloque de la app tal cual (nunca un botón propio) */
  setTimeout(function(){
    var h=document.getElementById('nkReleasitHost');
    if(h&&!h.querySelector(NK_RSI_BTN)&&!h.classList.contains('nkb-host--visible')) h.classList.add('nkb-host--visible');
  },8000);
})();

/* nk — mini-vídeos "Elegido por miles" (script21 de la fuente) */
(()=>{const root=document.querySelector('[data-trn1-root]');if(!root)return;root.querySelectorAll('[data-trn1-mini-card]').forEach(card=>{const v=card.querySelector('video'),b=card.querySelector('[data-trn1-mini-toggle]');if(!v||!b)return;const first=()=>{if(v.readyState>=1&&v.currentTime<.001){try{v.currentTime=.001}catch(_){}}};v.addEventListener('loadedmetadata',first,{once:true});v.addEventListener('loadeddata',first,{once:true});if(v.readyState>=1)first();b.addEventListener('click',()=>{if(v.paused){root.querySelectorAll('.trn1__mini-video').forEach(o=>{if(o!==v)o.pause()});v.muted=false;const p=v.play();if(p&&p.catch)p.catch(()=>{});}else v.pause()});v.addEventListener('play',()=>card.classList.add('is-playing'));v.addEventListener('pause',()=>card.classList.remove('is-playing'));v.addEventListener('ended',()=>{card.classList.remove('is-playing');try{v.currentTime=.001}catch(_){}});});})();

/* nk — galería, lightbox, packs, botón de compra y oferta fija (script22 de la fuente, compra → Releasit) */
(()=>{
const root=document.querySelector('[data-trn1-root]');
if(!root || root.dataset.ready==='1') return;
root.dataset.ready='1';
const track=root.querySelector('.trn1__gallery-track');
const slides=[...root.querySelectorAll('[data-trn1-slide]')];
const thumbs=[...root.querySelectorAll('[data-trn1-thumb]')];
const images=slides.map(s=>s.getAttribute('data-nk-lb-src')||((s.querySelector('img')||{}).currentSrc)||((s.querySelector('img')||{}).src)||'');
const thumbsRail=root.querySelector('.trn1__thumbs');
let index=0, lbIndex=0;
const syncThumbs=(smooth=true)=>{
thumbs.forEach((t,i)=>{const on=i===index;if(t.classList.contains('is-active')!==on)t.classList.toggle('is-active',on)});
const activeThumb=thumbs[index];
if(!thumbsRail || !activeThumb || thumbsRail.offsetParent===null) return;
const railRect=thumbsRail.getBoundingClientRect();
const thumbRect=activeThumb.getBoundingClientRect();
const delta=(thumbRect.left+thumbRect.width/2)-(railRect.left+railRect.width/2);
if(Math.abs(delta)>2) thumbsRail.scrollBy({left:delta,behavior:smooth?'smooth':'auto'});
};
const go=(n,smooth=true)=>{
if(!slides.length||!track) return;
index=(n+slides.length)%slides.length;
const slide=slides[index];
track.scrollTo({left:slide.offsetLeft-track.offsetLeft,behavior:smooth?'smooth':'auto'});
syncThumbs(smooth);
};
if(slides.length&&track){
syncThumbs(false);
const prev=root.querySelector('[data-trn1-prev]'),next=root.querySelector('[data-trn1-next]');
if(prev) prev.addEventListener('click',()=>go(index-1));
if(next) next.addEventListener('click',()=>go(index+1));
thumbs.forEach((t,i)=>t.addEventListener('click',()=>go(i)));
let scrollTimer;
track.addEventListener('scroll',()=>{
clearTimeout(scrollTimer);
scrollTimer=setTimeout(()=>{
let nearest=0,dist=Infinity;
slides.forEach((s,i)=>{const d=Math.abs(s.offsetLeft-track.offsetLeft-track.scrollLeft);if(d<dist){dist=d;nearest=i}});
if(nearest!==index){index=nearest; syncThumbs(true);}
},70);
},{passive:true});
}
const lightbox=root.querySelector('[data-trn1-lightbox]');
const lbImg=root.querySelector('[data-trn1-lb-img]');
if(lightbox&&lbImg&&images.length){
const openLb=(n)=>{lbIndex=n;lbImg.src=images[n];if(typeof lightbox.showModal==='function') lightbox.showModal(); else lightbox.setAttribute('open','');};
const closeLb=()=>{if(typeof lightbox.close==='function') lightbox.close(); else lightbox.removeAttribute('open');};
slides.forEach((s,i)=>s.addEventListener('click',()=>openLb(i)));
const c=root.querySelector('[data-trn1-lb-close]'),p=root.querySelector('[data-trn1-lb-prev]'),n=root.querySelector('[data-trn1-lb-next]');
if(c) c.addEventListener('click',closeLb);
if(p) p.addEventListener('click',()=>{lbIndex=(lbIndex-1+images.length)%images.length;lbImg.src=images[lbIndex]});
if(n) n.addEventListener('click',()=>{lbIndex=(lbIndex+1)%images.length;lbImg.src=images[lbIndex]});
lightbox.addEventListener('click',(e)=>{if(e.target===lightbox)closeLb()});
}
const packs=[...root.querySelectorAll('[data-trn1-pack]')];
const atc=root.querySelector('[data-trn1-atc]');
const atcLabel=root.querySelector('[data-trn1-atc-label]');
const status=root.querySelector('[data-trn1-cart-status]');
const suffix=atc?(atc.getAttribute('data-nk-atc-suffix')||''):'';
const select=(i)=>{
if(!packs[i]) return;
window.NK_SELECTED_IDX=i;
packs.forEach((x,j)=>{const on=j===i;if(x.classList.contains('is-selected')!==on)x.classList.toggle('is-selected',on);const a=String(on);if(x.getAttribute('aria-checked')!==a)x.setAttribute('aria-checked',a)});
const label=(packs[i].getAttribute('data-price-label')||'')+(suffix?' · '+suffix:'');
if(atcLabel&&label&&atcLabel.textContent!==label) atcLabel.textContent=label;
if(status&&status.textContent) status.textContent='';
};
let initial=packs.findIndex(p=>p.classList.contains('is-selected'));
if(initial<0) initial=Math.min(1,packs.length-1);
if(packs.length) select(initial);
packs.forEach((p,i)=>p.addEventListener('click',()=>select(i)));
const openCod=()=>{
if(window.nkOpenReleasit&&window.nkOpenReleasit()) return true;
const host=document.getElementById('nkReleasitHost')||root.querySelector('#trn1-buy');
if(host){try{host.scrollIntoView({behavior:'smooth',block:'center'})}catch(e){host.scrollIntoView()}}
return false;
};
if(atc) atc.addEventListener('click',(e)=>{e.preventDefault();openCod();});
const featuredIdx=()=>{const f=packs.findIndex(p=>p.classList.contains('trn1__pack--featured'));return f>=0?f:Math.min(1,packs.length-1);};
document.addEventListener('click',(e)=>{
const b=e.target&&e.target.closest?e.target.closest('[data-nk-open-cod]'):null; if(!b) return;
e.preventDefault(); if(packs.length) select(featuredIdx()); openCod();
});
const stickyOffer=root.querySelector('[data-trn1-sticky-offer]');
const buyBox=root.querySelector('.trn1__product-grid');
const stickyAtc=stickyOffer ? stickyOffer.querySelector('[data-trn1-sticky-atc]') : null;
let purchaseEndY=null;
const currentScrollY=()=>window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0;
const measurePurchaseEnd=()=>{
if(!buyBox) return;
const r=buyBox.getBoundingClientRect();
purchaseEndY=currentScrollY()+r.bottom;
};
const syncSticky=()=>{
if(!stickyOffer) return;
if(!buyBox){
if(stickyOffer.classList.contains('is-before-purchase')) stickyOffer.classList.remove('is-before-purchase');
return;
}
const r=buyBox.getBoundingClientRect();
if(purchaseEndY===null) measurePurchaseEnd();
const passed=(r.bottom <= 0) || (purchaseEndY!==null && currentScrollY() >= purchaseEndY-2);
if(stickyOffer.classList.contains('is-before-purchase')===passed) stickyOffer.classList.toggle('is-before-purchase', !passed);
};
if(stickyOffer){
stickyOffer.classList.add('is-before-purchase');
measurePurchaseEnd();
syncSticky();
if('IntersectionObserver' in window && buyBox){
const stickyObserver=new IntersectionObserver(()=>syncSticky(),{root:null,threshold:[0,0.01,0.5,1]});
stickyObserver.observe(buyBox);
}
window.addEventListener('scroll',syncSticky,{passive:true});
window.addEventListener('resize',()=>{measurePurchaseEnd();syncSticky()},{passive:true});
window.addEventListener('load',()=>{measurePurchaseEnd();syncSticky()});
document.addEventListener('shopify:section:load',syncSticky);
}
if(stickyAtc){
stickyAtc.addEventListener('click',(e)=>{e.preventDefault();if(packs.length) select(featuredIdx());openCod();});
}
})();

/* nk — vídeo-testimonios (script23 de la fuente) */
(()=>{const root=document.querySelector('[data-trn4-root]');if(!root||root.dataset.ready==='1')return;root.dataset.ready='1';
root.querySelectorAll('[data-trn1-video-card]').forEach(card=>{const video=card.querySelector('video'),play=card.querySelector('[data-trn1-video-play]');if(!video||!play)return;
const first=()=>{if(video.readyState>=1&&video.currentTime<.001){try{video.currentTime=.001}catch(_){}}};
video.addEventListener('loadedmetadata',first,{once:true});video.addEventListener('loadeddata',first,{once:true});if(video.readyState>=1)first();
play.addEventListener('click',()=>{root.querySelectorAll('.trn1__ugc-video').forEach(v=>{if(v!==video){v.pause();const c=v.closest('[data-trn1-video-card]');if(c)c.classList.remove('is-playing')}});
video.muted=false;video.setAttribute('controls','');const p=video.play();if(p&&p.catch)p.catch(()=>{video.muted=true;video.play()});card.classList.add('is-playing')});
video.addEventListener('ended',()=>{card.classList.remove('is-playing');video.removeAttribute('controls');video.muted=true;try{video.currentTime=.001}catch(_){}});});})();

/* nk — flechas de los carruseles trn2 (antes onclick inline de la fuente) */
document.addEventListener('click',function(e){
  var b=e.target&&e.target.closest?e.target.closest('[data-nk-rail]'):null; if(!b) return;
  var rail=document.getElementById(b.getAttribute('data-nk-rail')); if(!rail) return;
  e.preventDefault();
  rail.scrollBy({left:parseInt(b.getAttribute('data-nk-step'),10)||0,behavior:'smooth'});
});

/* nk — políticas del footer (script24 de la fuente; textos desde <template data-nk-policy>) */
(()=>{
const root=document.querySelector('[data-trn3-root]');
if(!root || root.dataset.ready==='1') return;
root.dataset.ready='1';
const modal=root.querySelector('[data-trn3-modal]');
const title=root.querySelector('[data-trn3-title]');
const copy=root.querySelector('[data-trn3-copy]');
const close=root.querySelector('[data-trn3-close]');
if(!modal||!title||!copy) return;
const openPolicy=(key)=>{
const tpl=root.querySelector('template[data-nk-policy="'+key+'"]'); if(!tpl) return;
title.textContent=tpl.getAttribute('data-title')||'';
copy.innerHTML=tpl.innerHTML;
if(typeof modal.showModal==='function') modal.showModal(); else modal.setAttribute('open','');
};
root.querySelectorAll('[data-trn3-policy]').forEach(btn=>btn.addEventListener('click',()=>openPolicy(btn.dataset.trn3Policy)));
const closeModal=()=>{if(typeof modal.close==='function') modal.close(); else modal.removeAttribute('open')};
if(close) close.addEventListener('click',closeModal);
modal.addEventListener('click',(e)=>{if(e.target===modal) closeModal()});
})();
